function typeEffect(elementId, words, speed = 150, delay = 1000) {
	// Error Handling: Check if elementId is valid
	let element = document.getElementById(elementId);
	if (!element) {
		console.error(`Element with id "${elementId}" not found.`);
		return;
	}

	// Error Handling: Check if words is a valid array of strings
	if (!Array.isArray(words) || words.length === 0) {
		console.error("The 'words' parameter should be a non-empty array of strings.");
		return;
	}
	for (let word of words) {
		if (typeof word !== "string") {
			console.error("All elements in the 'words' array should be strings.");
			return;
		}
	}

	// Error Handling: Validate that speed and delay are positive numbers
	if (typeof speed !== "number" || speed <= 0) {
		console.error("The 'speed' parameter should be a positive number.");
		return;
	}

	if (typeof delay !== "number" || delay < 0) {
		console.error("The 'delay' parameter should be a non-negative number.");
		return;
	}

	let wordIndex = 0;
	let charIndex = 0;
	let deleting = false;

	// Set aria-label with full words for accessibility
	element.setAttribute("aria-label", words.join(", "));

	// Prevent layout shift by setting a fixed width based on the longest word
	const longestWord = words.reduce((a, b) => (a.length > b.length ? a : b), "");
	const tempSpan = document.createElement("span");
	const computedStyle = window.getComputedStyle(element);

	// Copy relevant styles to tempSpan
	tempSpan.style.font = computedStyle.font;
	tempSpan.style.letterSpacing = computedStyle.letterSpacing;
	tempSpan.style.fontWeight = computedStyle.fontWeight;
	tempSpan.style.fontSize = computedStyle.fontSize;
	tempSpan.style.fontFamily = computedStyle.fontFamily;
	tempSpan.style.padding = computedStyle.padding;
	tempSpan.style.border = computedStyle.border;
	tempSpan.style.boxSizing = computedStyle.boxSizing;
	tempSpan.style.visibility = "hidden";
	tempSpan.style.position = "absolute";
	tempSpan.textContent = longestWord;

	document.body.appendChild(tempSpan);
	const fixedWidth = tempSpan.offsetWidth + 40; // Adding 40px buffer to prevent wrapping
	document.body.removeChild(tempSpan);

	element.style.display = "inline-block";
	element.style.width = `${fixedWidth}px`;

	function type() {
		let currentWord = words[wordIndex];

		if (!deleting) {
			element.textContent = currentWord.slice(0, charIndex++);
			if (charIndex > currentWord.length) {
				deleting = true;
				setTimeout(type, delay);
				return;
			}
		} else {
			element.textContent = currentWord.slice(0, charIndex--);
			if (charIndex < 0) {
				deleting = false;
				wordIndex = (wordIndex + 1) % words.length;
				charIndex = 0; // Fix to ensure next word starts from the beginning
				setTimeout(type, speed); // Ensure proper timing
				return;
			}
		}
		setTimeout(type, speed);
	}

	type();
}
